import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../../services/AuthService';
import { useAuth } from '../../context/AuthContext';
import './Login.css';

const Login = () => {
    const { setToken } = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [rememberMe, setRememberMe] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        setErrorMessage(''); // reset on new attempt
        try {
            await authService.login({ username: email, password }, setToken);
            window.location.href = '/dashboard';
        } catch (error) {
            console.error(error);
            setErrorMessage('Invalid username or password. Please try again.');
        }
    };

    return (
        <div className="login-page">
            <div className="login-header box-shadow">
                <div className="container-fluid d-flex justify-content-between align-items-center">
                    <div className="brand-logo">
                        <a href="/">
                            <img src="images/logo.png" alt="Logo" />
                        </a>
                    </div>
                </div>
            </div>

            <div className="login-wrap d-flex align-items-center flex-wrap justify-content-center">
                <div className="container">
                    <div className="row justify-content-center">
                        {/* Show image on top for mobile, side for desktop */}
                        <div className="col-12 d-block d-md-none text-center mb-4">
                            <img src="images/login-page-img.png" alt="Login" className="img-fluid" style={{maxHeight: '200px'}} />
                        </div>
                        <div className="col-md-4 col-lg-5 d-none d-md-block">
                            <img src="images/login-page-img.png" alt="Login" className="img-fluid" />
                        </div>
                        {/* Login form */}
                        <div className="col-12 col-md-8 col-lg-7">
                            <div className="login-box bg-white box-shadow border-radius-10">
                                <div className="login-title">
                                    <h2 className="text-center text-secondary">Login To EPay</h2>
                                </div>
                                <form onSubmit={handleLogin}>
                                    {errorMessage && (
                                        <div className="alert alert-danger text-center mb-3">
                                            {errorMessage}
                                        </div>
                                    )}
                                    <div className="input-group custom">
                                        <input
                                            type="text"
                                            className="form-control form-control-lg"
                                            placeholder="Username"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                        />
                                        <div className="input-group-append custom">
                                            <span className="input-group-text">
                                                <span className="icon-text">👤</span>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="input-group custom">
                                        <input
                                            type="password"
                                            className="form-control form-control-lg"
                                            placeholder="**********"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                        />
                                        <div className="input-group-append custom">
                                            <span className="input-group-text">
                                                <span className="icon-text">🔒</span>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="row pb-30">
                                        <div className="col-6">
                                            <div className="custom-control custom-checkbox">
                                                <input
                                                    type="checkbox"
                                                    className="custom-control-input"
                                                    id="customCheck1"
                                                    checked={rememberMe}
                                                    onChange={(e) => setRememberMe(e.target.checked)}
                                                />
                                                <label className="custom-control-label" htmlFor="customCheck1">
                                                    Remember
                                                </label>
                                            </div>
                                        </div>
                                        {/* <div className="col-6">
                                            <div className="forgot-password">
                                                <a href="/forgot-password">Forgot Password</a>
                                            </div>
                                        </div> */}
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="input-group mb-0">
                                                <button
                                                    className="btn btn-secondary btn-lg btn-block"
                                                    type="submit"
                                                >
                                                    Sign In
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;